export default "__VITE_ASSET__rFm8_GRj__"